/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { tagName } from '@ember-decorators/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { isEmpty } from '@ember/utils';

@tagName('')
export default class Editor extends Component {
  @service api;
  @service apiErrors;
  @service store;
  @service features;
  @service environment;

  actionAbstract = null;
  isSaving = false;
  onSelect() {}
  onDeselect() {}

  get campaign() {
    return this.actionAbstract.action.belongsTo('campaign').value();
  }

  get _conditionTypes() {
    if (this.isOnlyEventAttributeEnabled) {
      return ['event_attribute'];
    }

    let conditionsTypes = ['attribute', 'event_attribute', 'event', 'segments_negatable', 'message'];

    if (this.shouldIncludeDeviceCondition) {
      conditionsTypes.push('device_attribute');
    }

    return conditionsTypes;
  }

  get isOnlyEventAttributeEnabled() {
    return this.campaign?.isWebhookTriggered ?? false;
  }

  get shouldIncludeDeviceCondition() {
    return this.environment.enabledAction('push');
  }

  get _typeDropdownOptions() {
    let { campaign } = this;

    if (campaign == null) {
      return [];
    }

    let options = [
      {
        label: 'Attribute',
        value: 'attribute',
      },
      {
        label: 'Event attribute',
        value: 'event_attribute',
      },
      {
        label: 'Event',
        value: 'event',
      },
      {
        label: 'Segment',
        value: 'segments_negatable',
      },
    ];

    let { isEventTriggered, isFormTriggered, event } = campaign;

    // only show event_attribute when the campaign is event or form triggered
    if (!isEventTriggered && !isFormTriggered) {
      options = options.filter((option) => option.value !== 'event_attribute');
    }

    return options.map((option) => {
      if (option.value !== 'event_attribute') {
        return option;
      }

      return {
        ...option,
        isDisabled: (isEventTriggered || isFormTriggered) && isEmpty(event),
      };
    });
  }

  @action
  selectConditionType(type) {
    this.actionAbstract.set('condition', {
      type,
    });
  }

  @action
  onEditCondition(condition) {
    this.actionAbstract.set('condition', condition);
  }
}
